import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton for list items with avatar (contacts, participants, messages).
 * @param {number} count - Number of skeleton rows to show
 */
export function ListItemSkeleton({ count = 5 }) {
  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 2,
            borderBottom: i < count - 1 ? '1px solid' : 'none',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant="circular" width={48} height={48} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="40%" height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
